import ConfigurablePadding from './_configurable-padding.js'
import ConfigurableBackground from './_configurable-background.js'
import BorderStyle from './_border-style.js'
import ConfigurableFlex from './_configurable-flex.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableText from './_configurable-text.js'
import ConfigurablePane from './_configurable-pane.js'
import Animation from './_animation.js'
import ImageButton from './_image-button.js'
import ScrollPane from './_scroll-pane.js'
import Overlay from './_overlay.js'
import AbsolutePane from './_absolute-pane.js'

export default {
  name: 'Dialog',
  values: {
    layoutType: 'centered',
    _mobile_layoutType: 'fullscreen',
    allowScrolling: true,
    fullscreen: {
      top: 'env(safe-area-inset-top, 0px)',
      bottom: 'env(safe-area-inset-bottom, 0px)',
      left: 'env(safe-area-inset-left, 0px)',
      right: 'env(safe-area-inset-right, 0px)',
    },
    centered: {
      width: '376px',
      minWidth: '376px',
      height: 'auto',
      minHeight: undefined,
      maxHeight: '100vh',
      maxWidth: undefined,
      padding: undefined,
      boxSizing: undefined,
      $mixin: [
        {
          configSet: ConfigurablePadding,
        },
      ],
    },
    padding: '0',
    background: {
      $mixin: [
        {
          configSet: ConfigurableBackground,
        },
      ],
    },
    borderStyle: {
      configSet: BorderStyle,
      configValues: {},
    },
    overflow: 'hidden',
    header: {
      container: {
        style: {
          height: '40px',
          padding: '2px',
          margin: '0',
          $mixin: [
            {
              configSet: ConfigurableFlex,
            },
            {
              configSet: ConfigurableBackground,
            },
          ],
        },
        borderStyle: {
          configSet: BorderStyle,
          configValues: {
            borderWidth: '0 0 1px 0',
            borderColor: 'white',
          },
        },
      },
      title: {
        padding: '10px 0',
        $mixin: [
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      titleText: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      closeButtonContainer: {
        top: '4px',
        right: '4px',
      },
    },
    contentContainer: {
      margin: 0,
      padding: '24px 40px',
      height: 'auto',
    },
    footerContainer: {
      zIndex: '1',
      $mixin: [
        {
          configSet: ConfigurablePane,
        },
      ],
    },
    disabledOverlay: {
      $mixin: [
        {
          configSet: ConfigurableBackground,
        },
      ],
    },
    animating: {
      openAnimation: {
        configSet: Animation,
        configValues: {
          animationDuration: '0.3s',
          keyframes: {
            from: {
              opacity: 0,
              transform: 'scale(0.9)',
            },
            to: {
              opacity: 1,
              transform: 'scale(1)',
            },
          },
        },
      },
      closeAnimation: {
        configSet: Animation,
        configValues: {
          animationDuration: '0.3s',
          keyframes: {
            from: {
              opacity: 1,
              transform: 'scale(1)',
            },
            to: {
              opacity: 0,
              transform: 'scale(0.9)',
            },
          },
        },
      },
    },
    closeButton: {
      configSet: ImageButton,
      configValues: {
        buttonIcon: {
          src: 'close',
          style: {
            minWidth: '13px',
            minHeight: '13px',
          },
        },
      },
    },
    scrollPane: {
      configSet: ScrollPane,
      configValues: {
        direction: 'y',
      },
    },
    overlay: {
      configSet: Overlay,
      configValues: {},
    },
    closeButtonContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          zIndex: 1001,
          top: 0,
          right: 0,
          height: '40px',
          width: '40px',
          padding: '0',
          _mobile_top: '-48px',
          _mobile_height: '48px',
          _mobile_width: '48px',
          _mobile_padding: '4px',
          boxSizing: 'border-box',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
